import {
	SET_TRANSACTIONS,
	SET_TRANSACTION,
	CLEAR_TRANSACTIONS,
	CLEAR_TRANSACTION,
	ADD_TRANSACTION,
	UPDATE_TRANSACTION,
	REMOVE_TRANSACTION,
} from './actionTypes';

export const transaction = (state = {}, action) => {
	switch (action.type) {
		case SET_TRANSACTION:
			return action.payload;
		case UPDATE_TRANSACTION:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_TRANSACTION:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_TRANSACTIONS:
			return action.payload;
		case ADD_TRANSACTION:
			return [...state, action.payload];
		case UPDATE_TRANSACTION:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_TRANSACTION:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_TRANSACTIONS:
			return [];
		default:
			return state;
	}
};
